<!-- Like.vue -->
<template>
	<div
		class="ui-like-wrapper"
		v-if="detailInfo && detailInfo.pintuan_type==1"
	>
		<div class="explain">
			<h2>This product is joining the group</h2>
			<span class="desc">Maximum purchase of {{detailInfo.pintuan_limit_quantity}} pieces per person</span>
			<span class="desc">Group within {{detailInfo.pintuan_limit_hour}} hours</span>
			<span class="desc">Number of people in the group {{detailInfo.pintuan_limit_number}}</span>
		</div>
		<!--<div v-for="(item,index) in detailInfo.pintuangroup_list" :key="index">-->
		<!--<div class="ui-detail-common">-->
			<!--<div class="header">-->
				<!--<span>点赞</span> <span>1</span>-->
			<!--</div>-->
		<!--</div>-->

		<!--<div class="like-body">-->
			<!--<div-->
				<!--v-for="(item, index) in detailInfo.collector"-->
				<!--v-if="index < 10"-->
				<!--v-bind:key="index"-->
			<!--&gt;-->
				<!--<img :src="item.thumb" v-if="item.thumb" />-->

			<!--</div>-->
		<!--</div>-->
	<!--</div>-->
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {}
  },

  mounted () {},

  created () {},

  computed: {
    ...mapState({
      detailInfo: state => state.goodsdetail.detailInfo
    })
  }
}
</script>

<style lang="scss" scoped>
.ui-like-wrapper {
	background-color: #ffffff;
	margin-top:0.4rem;
	.explain{padding:.5rem;
		h2{color:$primaryColor;font-size:.8rem;padding-bottom: .5rem;}
		.desc{font-size:.7rem;color:gray;padding-right:.5rem;margin-right:.5rem;border-right:1px solid #e1e1e1}
		.desc:last-child{padding-right:0;margin-right:0;border-right:0}
	}
	.header {
		border-bottom: 0.5px solid #e8eaed;
		span:first-child {
			font-size: 0.7rem;
			color: rgba(78, 84, 93, 1);
			line-height:1rem;
		}
		span:last-child {
			font-size: 0.65rem;
			color: #333;
			line-height:0.9rem;
		}
	}

}
</style>
